import { render, staticRenderFns } from "./MovementContent.vue?vue&type=template&id=7dff5585&"
import script from "./MovementContent.vue?vue&type=script&lang=js&"
export * from "./MovementContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports